import { FormikFormValues } from "../../../pages/operations/pickup-request-sheet/CreatePickupRequestSheet";
import { PickupRequestSheetDetails, PickupRequestSheetList, PickupRequestSheetListSearch } from "../../../types/operations/pickupRequestSheetInterface";
import { PickupRequestSheetActionTypes, PickupRequestSheetActions } from "../../actionTypes/operations/pickupRequestSheetTypes";

export const getPickupRequestSheetList = (payload: PickupRequestSheetListSearch): PickupRequestSheetActionTypes => ({
  type: PickupRequestSheetActions.GET_PICKUP_REQUEST_SHEET_LIST,
  payload
});

export const setPickupRequestSheetList = (payload: Array<PickupRequestSheetList>): PickupRequestSheetActionTypes => ({
  type: PickupRequestSheetActions.SET_PICKUP_REQUEST_SHEET_LIST,
  payload
})

export const setPickupRequestSheetListCount = (payload: number): PickupRequestSheetActionTypes => ({
  type: PickupRequestSheetActions.SET_PICKUP_REQUEST_SHEET_PAGE_COUNT,
  payload
})

export const setPickupStatus = (payload: string): PickupRequestSheetActionTypes => ({
  type: PickupRequestSheetActions.SET_PICKUP_STATUS,
  payload
})

export const setPickupType = (payload: string): PickupRequestSheetActionTypes => ({
  type: PickupRequestSheetActions.SET_PICKUP_TYPE,
  payload
})

export const createPickupRequestSheet = (payload: {values: FormikFormValues, formikAction: any}): PickupRequestSheetActionTypes => ({
  type: PickupRequestSheetActions.CREATE_PICKUP_REQUEST_SHEET,
  payload
})

export const editPickupRequestSheetById = (payload: {values: FormikFormValues, prsId: string}): PickupRequestSheetActionTypes => ({
  type: PickupRequestSheetActions.EDIT_PICKUP_REQUEST_SHEET_BY_ID,
  payload
})

export const getPickupRequestSheetDataById = (id: string): PickupRequestSheetActionTypes => ({
  type: PickupRequestSheetActions.GET_PICKUP_REQUEST_SHEET_BY_ID,
  payload: id
})

export const setPickupRequestSheetDataById = (payload: PickupRequestSheetDetails): PickupRequestSheetActionTypes => ({
  type: PickupRequestSheetActions.SET_PICKUP_REQUEST_SHEET_BY_ID,
  payload
})